const creators = [
  {
    id: 0,
    name: "peetben",
    walletAddress: "0xeD98464BDA3cE53a95B50f897556bEDE4316361c",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/h9wai4uoq-20220404121423-jpg-1el0g7.jpg?q=45&w=50&h=50&auto=format%2Ccompress&fit=crop&dpr=2",
    joined: "12/23/2021",

    followData: {
      following: 16,
      followers: 2308,
    },

    launch: {
      collections: {
        count: 2,
      },
      created: {
        count: 28,
      },
    },

    collectors: {
      unique: 33,
      list: [
        {
          name: "foo",
        },
        {
          name: "bar",
        },
      ],
    },

    sales: {
      currency: "ETH",
      today: {
        quantity: 2,
        primary: 1.07,
        secondary: 0.2,
        total: 1.27,
      },
      week: {
        quantity: 4,
        primary: 5,
        secondary: 3.5,
        total: 8.5,
      },
      month: {
        quantity: 4,
        primary: 5,
        secondary: 3.5,
        total: 8.5,
      },
    },

    socialMedia: {
      links: {
        website:
          "http://irs.gov/libero/rutrum/ac/lobortis/vel.jpg?morbi=quam&a=nec&ipsum=dui&integer=luctus&a=rutrum&nibh=nulla&in=tellus&quis=in&justo=sagittis&maecenas=dui&rhoncus=vel&aliquam=nisl&lacus=duis&morbi=ac&quis=nibh&tortor=fusce&id=lacus&nulla=purus&ultrices=aliquet&aliquet=at&maecenas=feugiat&leo=non&odio=pretium&condimentum=quis&id=lectus&luctus=suspendisse&nec=potenti&molestie=in&sed=eleifend&justo=quam&pellentesque=a&viverra=odio&pede=in&ac=hac&diam=habitasse&cras=platea&pellentesque=dictumst&volutpat=maecenas&dui=ut&maecenas=massa&tristique=quis&est=augue&et=luctus&tempus=tincidunt&semper=nulla&est=mollis&quam=molestie&pharetra=lorem&magna=quisque&ac=ut&consequat=erat&metus=curabitur&sapien=gravida&ut=nisi&nunc=at&vestibulum=nibh&ante=in&ipsum=hac&primis=habitasse&in=platea&faucibus=dictumst",
        discord:
          "https://bandcamp.com/vel/augue/vestibulum.json?dolor=nulla&quis=tempus&odio=vivamus&consequat=in&varius=felis&integer=eu&ac=sapien&leo=cursus&pellentesque=vestibulum&ultrices=proin&mattis=eu&odio=mi&donec=nulla&vitae=ac&nisi=enim&nam=in&ultrices=tempor&libero=turpis&non=nec&mattis=euismod&pulvinar=scelerisque&nulla=quam&pede=turpis&ullamcorper=adipiscing&augue=lorem&a=vitae&suscipit=mattis&nulla=nibh&elit=ligula&ac=nec&nulla=sem&sed=duis",
        medium:
          "https://soundcloud.com/at/diam/nam/tristique/tortor/eu/pede.jpg?vulputate=id&nonummy=sapien&maecenas=in&tincidunt=sapien&lacus=iaculis&at=congue&velit=vivamus&vivamus=metus&vel=arcu&nulla=adipiscing&eget=molestie&eros=hendrerit&elementum=at&pellentesque=vulputate&quisque=vitae&porta=nisl&volutpat=aenean&erat=lectus&quisque=pellentesque&erat=eget&eros=nunc&viverra=donec&eget=quis&congue=orci&eget=eget&semper=orci&rutrum=vehicula&nulla=condimentum&nunc=curabitur&purus=in&phasellus=libero&in=ut&felis=massa&donec=volutpat&semper=convallis&sapien=morbi&a=odio&libero=odio&nam=elementum&dui=eu&proin=interdum&leo=eu&odio=tincidunt&porttitor=in&id=leo&consequat=maecenas&in=pulvinar&consequat=lobortis&ut=est",
        telegram:
          "https://eepurl.com/primis.png?ligula=aliquam&in=sit&lacus=amet&curabitur=diam&at=in&ipsum=magna&ac=bibendum&tellus=imperdiet&semper=nullam&interdum=orci&mauris=pede&ullamcorper=venenatis&purus=non&sit=sodales&amet=sed&nulla=tincidunt&quisque=eu&arcu=felis&libero=fusce&rutrum=posuere&ac=felis&lobortis=sed&vel=lacus&dapibus=morbi&at=sem",
        instagram:
          "http://desdev.cn/cursus/vestibulum.js?nulla=nibh&tempus=in&vivamus=hac&in=habitasse&felis=platea&eu=dictumst&sapien=aliquam&cursus=augue&vestibulum=quam&proin=sollicitudin&eu=vitae&mi=consectetuer&nulla=eget&ac=rutrum&enim=at&in=lorem&tempor=integer&turpis=tincidunt&nec=ante&euismod=vel&scelerisque=ipsum&quam=praesent&turpis=blandit&adipiscing=lacinia&lorem=erat&vitae=vestibulum&mattis=sed&nibh=magna&ligula=at&nec=nunc&sem=commodo&duis=placerat",
      },
    },
  },
  {
    id: 1,
    name: "LOREM",
    walletAddress: "0xeB13464BDA3cE53a95B50f897556bEDE431612c1",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/b5ntxi745-lorem2-gif-83idv8.gif?q=45&w=50&h=50&auto=format%2Ccompress&fit=crop&dpr=2",
    joined: "01/01/2022",

    followData: {
      following: 33,
      followers: 1209,
    },

    launch: {
      collections: {
        count: 2,
      },
      created: {
        count: 28,
      },
    },

    collectors: {
      unique: 12,
      list: [
        {
          name: "foo",
        },
        {
          name: "bar",
        },
      ],
    },

    sales: {
      currency: "ETH",
      today: {
        quantity: 1,
        primary: 1.8,
        secondary: 1.8,
        total: 3.6,
      },
      week: {
        quantity: 12,
        primary: 7.07,
        secondary: 12.2,
        total: 19.27,
      },
      month: {
        quantity: 33,
        primary: 8.87,
        secondary: 12.2,
        total: 30.07,
      },
    },

    socialMedia: {
      links: {
        website:
          "http://irs.gov/libero/rutrum/ac/lobortis/vel.jpg?morbi=quam&a=nec&ipsum=dui&integer=luctus&a=rutrum&nibh=nulla&in=tellus&quis=in&justo=sagittis&maecenas=dui&rhoncus=vel&aliquam=nisl&lacus=duis&morbi=ac&quis=nibh&tortor=fusce&id=lacus&nulla=purus&ultrices=aliquet&aliquet=at&maecenas=feugiat&leo=non&odio=pretium&condimentum=quis&id=lectus&luctus=suspendisse&nec=potenti&molestie=in&sed=eleifend&justo=quam&pellentesque=a&viverra=odio&pede=in&ac=hac&diam=habitasse&cras=platea&pellentesque=dictumst&volutpat=maecenas&dui=ut&maecenas=massa&tristique=quis&est=augue&et=luctus&tempus=tincidunt&semper=nulla&est=mollis&quam=molestie&pharetra=lorem&magna=quisque&ac=ut&consequat=erat&metus=curabitur&sapien=gravida&ut=nisi&nunc=at&vestibulum=nibh&ante=in&ipsum=hac&primis=habitasse&in=platea&faucibus=dictumst",
        discord:
          "https://bandcamp.com/vel/augue/vestibulum.json?dolor=nulla&quis=tempus&odio=vivamus&consequat=in&varius=felis&integer=eu&ac=sapien&leo=cursus&pellentesque=vestibulum&ultrices=proin&mattis=eu&odio=mi&donec=nulla&vitae=ac&nisi=enim&nam=in&ultrices=tempor&libero=turpis&non=nec&mattis=euismod&pulvinar=scelerisque&nulla=quam&pede=turpis&ullamcorper=adipiscing&augue=lorem&a=vitae&suscipit=mattis&nulla=nibh&elit=ligula&ac=nec&nulla=sem&sed=duis",
        medium:
          "https://soundcloud.com/at/diam/nam/tristique/tortor/eu/pede.jpg?vulputate=id&nonummy=sapien&maecenas=in&tincidunt=sapien&lacus=iaculis&at=congue&velit=vivamus&vivamus=metus&vel=arcu&nulla=adipiscing&eget=molestie&eros=hendrerit&elementum=at&pellentesque=vulputate&quisque=vitae&porta=nisl&volutpat=aenean&erat=lectus&quisque=pellentesque&erat=eget&eros=nunc&viverra=donec&eget=quis&congue=orci&eget=eget&semper=orci&rutrum=vehicula&nulla=condimentum&nunc=curabitur&purus=in&phasellus=libero&in=ut&felis=massa&donec=volutpat&semper=convallis&sapien=morbi&a=odio&libero=odio&nam=elementum&dui=eu&proin=interdum&leo=eu&odio=tincidunt&porttitor=in&id=leo&consequat=maecenas&in=pulvinar&consequat=lobortis&ut=est",
        telegram:
          "https://eepurl.com/primis.png?ligula=aliquam&in=sit&lacus=amet&curabitur=diam&at=in&ipsum=magna&ac=bibendum&tellus=imperdiet&semper=nullam&interdum=orci&mauris=pede&ullamcorper=venenatis&purus=non&sit=sodales&amet=sed&nulla=tincidunt&quisque=eu&arcu=felis&libero=fusce&rutrum=posuere&ac=felis&lobortis=sed&vel=lacus&dapibus=morbi&at=sem",
        instagram:
          "http://desdev.cn/cursus/vestibulum.js?nulla=nibh&tempus=in&vivamus=hac&in=habitasse&felis=platea&eu=dictumst&sapien=aliquam&cursus=augue&vestibulum=quam&proin=sollicitudin&eu=vitae&mi=consectetuer&nulla=eget&ac=rutrum&enim=at&in=lorem&tempor=integer&turpis=tincidunt&nec=ante&euismod=vel&scelerisque=ipsum&quam=praesent&turpis=blandit&adipiscing=lacinia&lorem=erat&vitae=vestibulum&mattis=sed&nibh=magna&ligula=at&nec=nunc&sem=commodo&duis=placerat",
      },
    },
  },
  {
    id: 2,
    name: "helena sarin",
    walletAddress: "0xeA312364BDA3cE53a95B50f897556bEDE4316ffx3",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/04mi356nb-biophoto1-jpg-zkfom4.JPG?q=45&w=50&h=50&auto=format%2Ccompress&fit=crop&dpr=2",
    joined: "01/01/2022",

    followData: {
      following: 51,
      followers: 11,
    },

    launch: {
      collections: {
        count: 2,
      },
      created: {
        count: 28,
      },
    },

    collectors: {
      unique: 23,
      list: [
        {
          name: "foo",
        },
        {
          name: "bar",
        },
      ],
    },

    sales: {
      currency: "ETH",
      today: {
        quantity: 1,
        primary: 1.8,
        secondary: 1.8,
        total: 3.6,
      },
      week: {
        quantity: 12,
        primary: 7.07,
        secondary: 12.2,
        total: 19.27,
      },
      month: {
        quantity: 33,
        primary: 8.87,
        secondary: 12.2,
        total: 30.07,
      },
    },

    socialMedia: {
      links: {
        website:
          "http://irs.gov/libero/rutrum/ac/lobortis/vel.jpg?morbi=quam&a=nec&ipsum=dui&integer=luctus&a=rutrum&nibh=nulla&in=tellus&quis=in&justo=sagittis&maecenas=dui&rhoncus=vel&aliquam=nisl&lacus=duis&morbi=ac&quis=nibh&tortor=fusce&id=lacus&nulla=purus&ultrices=aliquet&aliquet=at&maecenas=feugiat&leo=non&odio=pretium&condimentum=quis&id=lectus&luctus=suspendisse&nec=potenti&molestie=in&sed=eleifend&justo=quam&pellentesque=a&viverra=odio&pede=in&ac=hac&diam=habitasse&cras=platea&pellentesque=dictumst&volutpat=maecenas&dui=ut&maecenas=massa&tristique=quis&est=augue&et=luctus&tempus=tincidunt&semper=nulla&est=mollis&quam=molestie&pharetra=lorem&magna=quisque&ac=ut&consequat=erat&metus=curabitur&sapien=gravida&ut=nisi&nunc=at&vestibulum=nibh&ante=in&ipsum=hac&primis=habitasse&in=platea&faucibus=dictumst",
        discord:
          "https://bandcamp.com/vel/augue/vestibulum.json?dolor=nulla&quis=tempus&odio=vivamus&consequat=in&varius=felis&integer=eu&ac=sapien&leo=cursus&pellentesque=vestibulum&ultrices=proin&mattis=eu&odio=mi&donec=nulla&vitae=ac&nisi=enim&nam=in&ultrices=tempor&libero=turpis&non=nec&mattis=euismod&pulvinar=scelerisque&nulla=quam&pede=turpis&ullamcorper=adipiscing&augue=lorem&a=vitae&suscipit=mattis&nulla=nibh&elit=ligula&ac=nec&nulla=sem&sed=duis",
        medium:
          "https://soundcloud.com/at/diam/nam/tristique/tortor/eu/pede.jpg?vulputate=id&nonummy=sapien&maecenas=in&tincidunt=sapien&lacus=iaculis&at=congue&velit=vivamus&vivamus=metus&vel=arcu&nulla=adipiscing&eget=molestie&eros=hendrerit&elementum=at&pellentesque=vulputate&quisque=vitae&porta=nisl&volutpat=aenean&erat=lectus&quisque=pellentesque&erat=eget&eros=nunc&viverra=donec&eget=quis&congue=orci&eget=eget&semper=orci&rutrum=vehicula&nulla=condimentum&nunc=curabitur&purus=in&phasellus=libero&in=ut&felis=massa&donec=volutpat&semper=convallis&sapien=morbi&a=odio&libero=odio&nam=elementum&dui=eu&proin=interdum&leo=eu&odio=tincidunt&porttitor=in&id=leo&consequat=maecenas&in=pulvinar&consequat=lobortis&ut=est",
        telegram:
          "https://eepurl.com/primis.png?ligula=aliquam&in=sit&lacus=amet&curabitur=diam&at=in&ipsum=magna&ac=bibendum&tellus=imperdiet&semper=nullam&interdum=orci&mauris=pede&ullamcorper=venenatis&purus=non&sit=sodales&amet=sed&nulla=tincidunt&quisque=eu&arcu=felis&libero=fusce&rutrum=posuere&ac=felis&lobortis=sed&vel=lacus&dapibus=morbi&at=sem",
        instagram:
          "http://desdev.cn/cursus/vestibulum.js?nulla=nibh&tempus=in&vivamus=hac&in=habitasse&felis=platea&eu=dictumst&sapien=aliquam&cursus=augue&vestibulum=quam&proin=sollicitudin&eu=vitae&mi=consectetuer&nulla=eget&ac=rutrum&enim=at&in=lorem&tempor=integer&turpis=tincidunt&nec=ante&euismod=vel&scelerisque=ipsum&quam=praesent&turpis=blandit&adipiscing=lacinia&lorem=erat&vitae=vestibulum&mattis=sed&nibh=magna&ligula=at&nec=nunc&sem=commodo&duis=placerat",
      },
    },
  },
];

export default creators;
